var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 2.66667L8.5 1M8.5 1L6.83333 2.66667M8.5 1V16M8.5 16L10.1667 14.3333M8.5 16L6.83333 14.3333M14.3333 10.1667L16 8.5M16 8.5L14.3333 6.83333M16 8.5H1M1 8.5L2.66667 10.1667M1 8.5L2.66667 6.83333",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToIcon);
export default __webpack_public_path__ + "static/media/move-to-icon.52fc615da4be0858811eac9fdeaa0107.svg";
export { ForwardRef as ReactComponent };